import styled from 'styled-components';
import { WebAsset } from '@styled-icons/material/WebAsset';
import { Tools } from '@styled-icons/fa-solid/Tools';
import { CaretDownFill } from '@styled-icons/bootstrap/CaretDownFill';
import { Edit } from '@styled-icons/material/Edit';

const NonMonitoredAssetDetailsParent = styled.div`
  .header-block {
    background: var(--sops-bg-white);
    box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.154802);
    padding: 24px;
    z-index: 2;
    height: 100px;
    border-bottom: 1px solid var(--sops-trans-white-border);
  }

  .content-block {
    height: calc(100% - 100px);
  }
`;

const ActionsPopoverBlock = styled.div`
  box-shadow: 1px 2px 25px rgba(0, 0, 0, 0.152945);
  border-radius: 8px;

  .tab-name-block {
    padding: 8px 16px;
    cursor: pointer;
  }

  .tab-name-block: hover {
    background-color: var(--sops-dropdown-hover-bg);
  }

  .tab-name {
    font-size: 14px;
    color: #ea2632;
  }
`;

export { NonMonitoredAssetDetailsParent, ActionsPopoverBlock };
